import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, message } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQueryClient } from "react-query";
import FormElement from "../../components/SampleTemplate/FormElement";
import sampleTemplateSchema from "../../schema/template.schema";
import { useGetSampleTemplateConfigById } from "../../hooks/sampletemplate";
import { sampleTemplateSetConfig } from "../../api/sampletemplate";
import { CenteredInputContainer, CardElement } from "../../components/Common/UIElements";

const cardStyle = { borderRadius: "20px" };

const SampleTemplate = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(sampleTemplateSchema),
  });

  const [userId, setUserId] = useState();

  useEffect(() => {
    setUserId(1132);
  }, []);

  const queryClient = useQueryClient();

  const { data: sampleConfigData } = useGetSampleTemplateConfigById(userId);
  const mutation = useMutation(sampleTemplateSetConfig, {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetSampleTemplateConfigById"]);
      message.success("User Config Updated");
    },
    onError: (error) => {
      message.error(error?.response?.data?.message);
    },
  });

  useEffect(() => {
    reset(sampleConfigData);
  }, [sampleConfigData]);

  return (
    <CardElement title="Sample Template">
      <div className="steps-content">
        <div style={{ textAlign: "left" }}>
          <CenteredInputContainer>
            <form
              onSubmit={handleSubmit((data) => {
                mutation.mutate({ id: userId, data });
              })}
            >
              <FormElement control={control} errors={errors} />
              <div style={{ textAlign: "center", marginTop: "30px" }}>
                <Button type="primary" htmlType="submit">
                  Next
                </Button>
              </div>
            </form>
          </CenteredInputContainer>
        </div>
      </div>
    </CardElement>
  );
};

SampleTemplate.propTypes = {};

export default SampleTemplate;
